import React, { useEffect, useState, useRef } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { EditOutlined } from "@ant-design/icons";
import { Tag, Button, Table, Input } from "antd";
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import FilterModal from "../../components/Pooling/FilterModal"; // Import the new FilterModal component
import PoolDetailsModal from "../../components/Pooling/PoolDetailsModal"; // Import the new FilterModal component
import FinalSettlePriceModal from "../../components/Pooling/FinalSettlePriceModal";
import "../../css/pooling.css";
import filterIcon from "../../assets/icons/pooling/filtericon.svg";
import cbWhiteIcon from "../../assets/icons/pooling/cb-white.svg";
import greenEyeIcon from "../../assets/icons/pooling/eye-green.svg";
import redEyeIcon from "../../assets/icons/pooling/eye-red.svg";
import surplusIcon from "../../assets/icons/pooling/surplus.svg";
import deficitIcon from "../../assets/icons/pooling/deficit.svg";
import dragIcon from "../../assets/icons/pooling/drag.svg";
import cbIcon from "../../assets/icons/pooling/cb.svg";
import cbRedIcon from "../../assets/icons/pooling/cb-red.svg";
import cbGreenIcon from "../../assets/icons/pooling/cb-green.svg";
import euroCurrencyIcon from "../../assets/icons/pooling/euroCurrency.svg";
import rocketIcon from "../../assets/icons/pooling/rocket.svg";
import resetloadingIcon from "../../assets/icons/pooling/resetloading.svg";
import closeIcon from "../../assets/icons/pooling/close.svg";
import { UpdateFinalPrice,getPoolRedirectData,filterSurplusPooling,filterDeficitPooling,saveOrUpdatePool,addDeficitFilterValue, addSurplusFilterValue,suggestionFilter,getManualPoolPricebreakdown } from "../../features/Pooling/PoolingSlice";
import { notification,Empty } from "antd";
import { useSelector,useDispatch } from "react-redux";
import VerticalBarLoader from "../../components/VerticalBarLoader";
import OnBoardingHead from "../../components/onboarding/OnBoardingHead";
import dayjs from "dayjs";
import { width } from "@mui/system";
import CommonHeader from "../../components/HeaderComponent/CommonHeader";
import { useLocation, useNavigate } from "react-router-dom";
import DistributionModal from "../../components/Pooling/DistributionModal";

const addThousandSeparator = (value) => {
  // Ensure the value is a valid number
  const number = parseFloat(value);

  if (isNaN(number)) {
    return ''; // Return an empty string for invalid input
  }

  // Format the number with thousand separators
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20, // Adjust to retain maximum precision if needed
  });
};

const openNotification = (type, message, description) => {
  notification[type]({
    message,
    description,
    placement: "topRight",
  });
};


const Pooling = () => {
  const dispatch = useDispatch();
  const currentYear = dayjs().startOf('year');
  const [dropApplied, setDropApplied] = useState(false);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const { surplusPoolingData,deficitPoolingData,initiatedpoolingloading,updatepoolingloading, poolRedirectData, initiatepoolstatus, filterSurplusValues, filterDeficitValues, intiatedpoolingData } = useSelector((state) => state.pooling);
  const [surplusVessels, setSurplusVessels] = useState([]);
  const [deficitVessels, setDeficitVessels] = useState([]);
  const [isPoolDetailsModalOpen, setIsPoolDetailsModalOpen] = useState(false);
  const [isDitributionModalOpen, setIsDitributionModalOpen] = useState(false);
  const [isFinalSettlePriceModalOpen, setIsFinalSettlePriceModalOpen] = useState(false);
  const [greenContainer, setGreenContainer] = useState([]);
  const [redContainer, setRedContainer] = useState([]);
  const [poolresetButton, setPoolresetButton] = useState(false);
  const [originalPoolChange, setoriginalPoolChange] = useState(false);
  const [updatePoolClicked, setupdatePoolClicked] = useState(false);
  const [filterType,setFilterType] = useState(null);
  const [brokerageMap,setBrokerageMap] = useState({});
  const [FinalSPMap,setFinalSPMap] = useState({});
  const [redirectedPoolId,setRedirectedPoolId] = useState("");
  const [redirectedPoolData,setRedirectedPoolData] = useState([]);
  const { user } = useSelector((state) => state.user);
  const [year,setYear] = useState({surplus:currentYear,deficit:currentYear});
  const scrollHeight = window.innerWidth > 1700 ? "48vh" : "48vh";
  const location = useLocation();
  const navigate = useNavigate();

  const [isRedirectedFromPoolingHistory,setisRedirectedFromPoolingHistory] = useState(false);

  useEffect(() => {
    if (!surplusPoolingData || !deficitPoolingData) return;
  
    const brokerageMap = {};
    const finalSPMap = {};
  
    surplusPoolingData.forEach(item => {
      brokerageMap[item.token_id] = item.broker_percentage;
      finalSPMap[item.token_id] = item.final_settlement_price ? item.final_settlement_price : 0;
    });
  
    deficitPoolingData.forEach(item => {
      brokerageMap[item.token_id] = item.broker_percentage;
      finalSPMap[item.token_id] = item.final_settlement_price ? item.final_settlement_price : 0;
    });
  
    setBrokerageMap(brokerageMap);
    setFinalSPMap(finalSPMap);
    console.log("payload", brokerageMap);
  }, [surplusPoolingData, deficitPoolingData]);
  

  const gettingpooldata = async (pool_id) => {
    try {
      const result = await dispatch(getPoolRedirectData({ pool_id: pool_id })).unwrap();
      const greenData = [];
      const redData = [];
  
      result.forEach(item => {
        console.log("item.cb_wants_to_sell", item.cb_wants_to_sell);
        if (item.cb_wants_to_sell >= 0) {
          greenData.push(item);
        } else {
          redData.push(item);
        }
      });
  
      console.log("location", location.state?.data?.from);
  
      if (location.state?.data?.from == "poolingHistory") {
        setGreenContainer(greenData);
        setRedContainer(redData);
        const combinedData = [...greenData, ...redData];
        setRedirectedPoolData(combinedData);
        setisRedirectedFromPoolingHistory(true);
        navigate(location.pathname, { replace: true }); 
      } else {
        setGreenContainer([]);
        setRedContainer([]);
      }
      console.log("containers", greenContainer, redContainer);
    } catch (err) {
      console.error("Failed to fetch pool data:", err);
    }
  };

  
  useEffect(() => {
    if (location.state?.data?.from === "poolingHistory") {
      const { pool_id } = location.state.data;
      console.log("Redirected from /poolingHistory with pool_id:", pool_id);
      gettingpooldata(pool_id);
      setRedirectedPoolId(pool_id);
    }
  }, [location.state]); 

  

  useEffect(() => {
    if (surplusPoolingData) {
      console.log("surplusPoolingData",surplusPoolingData,greenContainer)
      const filteredVessels = surplusPoolingData.filter(vessel => 
        !greenContainer.some(container => container.token_id == vessel.token_id) 
      );
      setSurplusVessels(filteredVessels); 
    }
    console.log("SurplusVessels",surplusVessels)

  }, [surplusPoolingData]);


  useEffect(() => {
    if (deficitPoolingData) {
      console.log("deficitPoolingData",deficitPoolingData,redContainer)

      const filteredVessels = deficitPoolingData.filter(vessel => 
        !redContainer.some(container => container.token_id == vessel.token_id) 
      );
      setDeficitVessels(filteredVessels); 
    }
  }, [deficitPoolingData]); 
  
  


  const [surplusFilters, setSurplusFilters] = useState([]);
  const [deficitFilters, setDeficitFilters] = useState([]);
  const [poolStatus, setPoolStatus] = useState(false);
  const [isFilterModalVisible, setFilterModalVisible] = useState(false);
  const [isInitiatePoolClicked, setInitiatePoolClicked] = useState(false);

  // Handle filter change: add or remove filter
  const handleFilterChange = async (type,filters) => {
    if(type=="surplus"){
      await dispatch(filterSurplusPooling(filters));
    }
    else if(type=="deficit"){
      await dispatch(filterDeficitPooling(filters));
    }
    else{
      await dispatch(filterDeficitPooling(filters));
      await dispatch(filterSurplusPooling(filters));
    }
  };

  useEffect(() => {
    if (filterSurplusValues[0]) {
      handleFilterChange("surplus", filterSurplusValues[0]);
    }
  }, [filterSurplusValues]);
  
  useEffect(() => {
    if (filterDeficitValues[0]) {
      handleFilterChange("deficit", filterDeficitValues[0]);
    }
  }, [filterDeficitValues]);
  

  const handleFinalSettlePrice = () => {
    setIsFinalSettlePriceModalOpen(true);
    console.log("isFinalSettlePriceModalOpen",isFinalSettlePriceModalOpen)

  };

  const handleFinalSettlePriceModalClose = () => {
    console.log("yes close")
    setIsFinalSettlePriceModalOpen(false);
  };

  const handlePoolDetailClose = () => {
    setIsPoolDetailsModalOpen(false); 
  }

  const handleDistribution = async () => {
    const combinedImoList = [
      ...greenContainer.map(item => item.imo_number),
      ...redContainer.map(item => item.imo_number)
    ];
    await dispatch(getManualPoolPricebreakdown({imo_list:combinedImoList,pool_id:redirectedPoolId?redirectedPoolId:""}));
    setIsDitributionModalOpen(true);
  }
  const handleInitiatePool = async (data) => {
    console.log("datadata",data)
    const result = await dispatch(saveOrUpdatePool({data:data,pool_id:redirectedPoolId}));
    if (result.type === "pooling/saveOrUpdatePool/fulfilled") {
      setPoolStatus(true);
      setInitiatePoolClicked(true);
      openNotification(
        "success",
        "Pool Saved",
        "Pooling data sent successfully."
      );
      setIsPoolDetailsModalOpen(true);
      setIsDitributionModalOpen(false);
      setDropApplied(true);
      setPoolresetButton(true);
    } else {
      console.error("Login Failed");
    }
  };


  const handleReset = () => {
    setInitiatePoolClicked(false);
    window.location.reload();
    setDropApplied(false);
  
  };

  useEffect(()=>{
    dispatch(addSurplusFilterValue(surplusFilters));
  },[surplusFilters])

  useEffect(()=>{
    dispatch(addDeficitFilterValue(deficitFilters));
  },[deficitFilters])

  const handleFilterClick = async (type) => {
      setFilterType(type);
      setFilterModalVisible(true);
      if(type==filterSurplusValues[0]?.request_type){
        await dispatch(suggestionFilter(filterSurplusValues[0]?.ship_owner ?{year:filterSurplusValues[0]?.year,ship_owner:filterSurplusValues[0].ship_owner}:null));
      }
      else if(type==filterDeficitValues[0]?.request_type){
        await dispatch(suggestionFilter(filterDeficitValues[0]?.ship_owner ?{year:filterDeficitValues[0].year,ship_owner:filterDeficitValues[0].ship_owner}:null));
      }
      else {
        await dispatch(suggestionFilter({year:currentYear.year()}));
      }
  };

  // Handle dropping items into containers
  const handleDrop = (_items, target) => {
    const items = Array.isArray(_items) ? _items : [_items];
  
    if (target === "green" && !dropApplied) {
      setGreenContainer((prev) => [...prev, ...items]);
      setSurplusVessels((prevVessels) =>
        prevVessels.filter((item) => !items.find((i) => i.token_id === item.token_id))
      );
    } else if (target === "red" && !dropApplied) {
      setRedContainer((prev) => [...prev, ...items]);
      setDeficitVessels((prevVessels) =>
        prevVessels.filter((item) => !items.find((i) => i.token_id === item.token_id))
      );
    }
  };
  
  


  const handleRemove = (token_id, container) => {
    if (container === "green") {
      setGreenContainer((prev) => prev.filter((item) => item.token_id !== token_id));
      setSurplusVessels((prevVessels) => [...prevVessels, greenContainer.find((item) => item.token_id === token_id)]);
    } else if (container === "red") {
      setRedContainer((prev) => prev.filter((item) => item.token_id !== token_id));
      setDeficitVessels((prevVessels) => [...prevVessels, redContainer.find((item) => item.token_id === token_id)]);
    }
  };
  

  // Filter vessels based on selected filters
  let filteredSurplusVessels = surplusVessels.filter((vessel) => {
    if (vessel.cb_wants_to_sell >= 0) return true;
    if (vessel.cb_wants_to_sell < 0) return true;
    return false;
  });

  let filteredDeficitVessels = deficitVessels.filter((vessel) => {
    if (vessel.cb_wants_to_sell >= 0) return true;
    if (vessel.cb_wants_to_sell < 0) return true;
    return false;
  });

  useEffect(()=>{
    console.log("is it updated")
  },[filteredSurplusVessels,filteredDeficitVessels])
  
  console.log("filteredDeficitVessels",deficitVessels,surplusVessels)

  const handleContainerReset = async ()=> {
    setGreenContainer([]);
    setRedContainer([]);
    // setRedirectedPoolId("");
    await dispatch(filterDeficitPooling({year:currentYear.year()}));
    await dispatch(filterSurplusPooling({year:currentYear.year()}));
  }

  useEffect(() => {
    const combinedData = [...greenContainer, ...redContainer];
    
    const allTokenIdsMatch = combinedData.length === poolRedirectData.length && 
    combinedData.every(item => 
      poolRedirectData.some(poolItem => poolItem.token_id === item.token_id)
    );

    if(allTokenIdsMatch || redContainer.length==0 || greenContainer.length == 0){
      setoriginalPoolChange(true);
    } else{
      setoriginalPoolChange(false);
    }
  
    console.log("Matching Data:", originalPoolChange,redContainer.length==0 || greenContainer.length == 0);
  }, [greenContainer, redContainer, poolRedirectData]);

  useEffect(() => {
    const combinedData = [...greenContainer, ...redContainer];
    
    const allTokenIdsMatch = combinedData.length === poolRedirectData.length && 
    combinedData.every(item => 
      poolRedirectData.some(poolItem => poolItem.token_id === item.token_id)
    );

    if(allTokenIdsMatch || redContainer.length==0 || greenContainer.length == 0){
      setoriginalPoolChange(true);
    } else{
      setoriginalPoolChange(false);
    }
  
    console.log("Matching Data:", originalPoolChange,redContainer.length==0 || greenContainer.length == 0);
  }, []);

  const handleDistributionCancel = () =>{
    setIsDitributionModalOpen(false);
  };

  const totalCb =(greenContainer.reduce((acc,item) => acc + item.cb_wants_to_sell,0)-Math.abs(redContainer.reduce((acc, item) => acc + item.cb_wants_to_sell, 0)))/10**6;
  

  const shouldDisableButton = totalCb < 0 || redContainer.length <= 0 || greenContainer.length <= 0;
  const UpdatePoolDisableButton = originalPoolChange || totalCb < 0 || redContainer.length <= 0 || greenContainer.length <= 0;
  console.log("Matching Data UpdatePoolDisableButton:", UpdatePoolDisableButton,isRedirectedFromPoolingHistory);

  return (
    <DndProvider backend={isTouchDevice ? TouchBackend : HTML5Backend}>
      <div className="pooling-container">
        <CommonHeader 
          headerKey="manual_pool" 
          headerTitle="Vessel Manual Pooling" 
          type="manual_pool"
          component={<Button type="primary" className="reset-pooling-containers" disabled={poolresetButton} onClick={handleContainerReset}>
            Reset Pool
          </Button>}  
        />

        <div className="page-components">
          
          {/* Filter Modal */}
          {isFilterModalVisible && (
            <FilterModal
              filterType={filterType}
              setSurplusFilters={setSurplusFilters}
              setDeficitFilters={setDeficitFilters}
              surplusFilters={surplusFilters}
              deficitFilters={deficitFilters}
              year={year}
              setYear={setYear}
              setRedContainer={setRedContainer}
              setGreenContainer={setGreenContainer}
              onClose={() => setFilterModalVisible(false)}
            />
          )}

          
          {isPoolDetailsModalOpen && initiatepoolstatus=='succeeded' && (
            <PoolDetailsModal isVisible={isPoolDetailsModalOpen} onClose={handlePoolDetailClose}/>
          )}

          {isDitributionModalOpen && (
            <DistributionModal handleInitiatePool={handleInitiatePool} isModalVisible={isDitributionModalOpen} setIsModalVisible={setIsDitributionModalOpen} handleCancel={handleDistributionCancel}  handleFinalSettlePriceModalClose={handleFinalSettlePriceModalClose} redirectedPoolId={redirectedPoolId}/>
          )}
  
          {/* List and Droppable Containers */}
          <div className="list-section">
            <div className="list-container">
              <div className="list list-surplus">
                <div className="list-header">
                  <div className="list-header-left">
                      {/* <img src={surplusIcon} /> */}
                      <span>Surplus Vessels</span>
                    </div>
                    <div className="list-header-right">
                      <Button
                        className="pooling-filter-button"
                        onClick={() => handleFilterClick("surplus")}
                      >
                        Filter <img src={filterIcon}/>
                      </Button>
                    </div>
                </div>
                
                <div className="divider-line"></div>
                <div className="list-content" style={{ justifyContent: filteredSurplusVessels.filter((item) => item.cb_wants_to_sell >= 0)
                  .sort((a, b) => a.vessel_name.localeCompare(b.vessel_name)).length == 0 ? "center" : "flex-start"}}>

                  {/* {filteredSurplusVessels
                  .filter((item) => item.cb_wants_to_sell >= 0)
                  .sort((a, b) => a.vessel_name.localeCompare(b.vessel_name))
                  .map((item) => (
                    <DraggableCard key={item.token_id} item={item} type="surplus" dropApplied={dropApplied} />
                  ))} */}
                <DraggableCardTable type="surplus" redirectedPoolData={redirectedPoolData} data={filteredSurplusVessels} setData={setSurplusVessels} dropApplied={dropApplied} scrollHeight={scrollHeight} setBrokerageMap={setBrokerageMap} setFinalSPMap={setFinalSPMap} filteredSurplusVessels={filteredSurplusVessels} filteredDeficitVessels={filteredDeficitVessels} />


                </div>
                
              </div>
              <div className="list list-deficit">
                <div className="list-header">
                  <div className="list-header-left">
                      {/* <img src={deficitIcon} /> */}
                      <span>Deficit Vessels</span>
                    </div>
                    <div className="list-header-right">
                      <Button
                        className="pooling-filter-button"
                        onClick={()=>handleFilterClick("deficit")}
                      >
                        Filter <img src={filterIcon}/>
                      </Button>
                    </div>
                </div>
                <div className="divider-line"></div>
                <div className="list-content" style={{ justifyContent: filteredDeficitVessels.filter((item) => item.cb_wants_to_sell < 0)
                  .sort((a, b) => a.vessel_name.localeCompare(b.vessel_name)).length == 0 ? "center" : "flex-start"}}>
                  {/* {filteredDeficitVessels
                  .filter((item) => item.cb_wants_to_sell < 0)
                  .sort((a, b) => a.vessel_name.localeCompare(b.vessel_name))
                  .map((item) => (
                    <DraggableCard key={item.token_id} item={item} type="deficit" dropApplied={dropApplied} />
                  ))} */}
                <DraggableCardTable redirectedPoolData={redirectedPoolData} redirectedPoolId={redirectedPoolId} FinalSPMap={FinalSPMap} brokerageMap={brokerageMap} type="deficit" data={filteredDeficitVessels} setData={setDeficitVessels} dropApplied={dropApplied} scrollHeight={scrollHeight} setBrokerageMap={setBrokerageMap} setFinalSPMap={setFinalSPMap} filteredSurplusVessels={filteredSurplusVessels} filteredDeficitVessels={filteredDeficitVessels} />
                </div>

              </div>
            </div>
          </div>

            <DroppableContainer
              allowedType={["surplus", "deficit"]} // both types allowed
              items={[...greenContainer,...redContainer]} 
              onDrop={(items) => {handleDrop(items,items.cb_wants_to_sell >= 0 ? "green" : "red")}}
              handleRemove={handleRemove}
              dropApplied={dropApplied}
              isInitiatePoolClicked={isInitiatePoolClicked}
              poolStatus={poolStatus}
              setIsPoolDetailsModalOpen={setIsPoolDetailsModalOpen}
              shouldDisableButton={shouldDisableButton}
              UpdatePoolDisableButton={UpdatePoolDisableButton}
              handleReset={handleReset}
              initiatedpoolingloading={initiatedpoolingloading}
              updatepoolingloading={updatepoolingloading}
              handleInitiatePool={handleInitiatePool}
              handleDistribution={handleDistribution}
              greenContainer={greenContainer}
              redContainer={redContainer}
              isRedirectedFromPoolingHistory={isRedirectedFromPoolingHistory}
              setupdatePoolClicked={setupdatePoolClicked}
              updatePoolClicked={updatePoolClicked}
            />
        </div>
      </div>
    </DndProvider>
  );
};

const DraggableTableRow = ({ index, className, style, record, dropApplied, ...restProps }) => {
  const row_type = record.cb_wants_to_sell >= 0 ? "surplus" : "deficit";

  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: row_type,
    item: record,
    canDrag: !dropApplied,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [dropApplied, record]);

  return (
    <tr
      ref={dragRef}
      className={className}
      style={{
        ...style,
        opacity: isDragging ? 0.4 : 1,
        cursor: dropApplied ? "not-allowed" : "move",
      }}
      {...restProps}
    />
  );
};


const DraggableCardTable = ({ redirectedPoolData,redirectedPoolId,FinalSPMap,brokerageMap,type, data, setData, dropApplied, scrollHeight,setBrokerageMap,setFinalSPMap,filteredSurplusVessels,filteredDeficitVessels }) => {
    
  const [editingField, setEditingField] = useState({ tokenId: null, field: null });
  const dispatch = useDispatch();

  const handleInputChange = (value, tokenId, field) => {

    const updated = data.map((item) => {
      if (item.token_id === tokenId) {
        return {
          ...item,
          [field === "broker_percentage" ? "broker_percentage" : "final_settlement"]: Number(value),
        };
      }
      return item;
    });
  
    // Push update to parent state
    setData(updated);
    console.log("before after",brokerageMap,FinalSPMap);
    
    if (field === "broker_percentage") {
      setBrokerageMap((prev) => ({
        ...prev,
        [tokenId]: Number(value),
      }));
    } else if (field === "final_settlement_price") {
      setFinalSPMap((prev) => ({
        ...prev,
        [tokenId]: Number(value),
      }));
    }
    console.log("before after",brokerageMap,FinalSPMap);
  };
  
  
  

  const toggleEdit = (tokenId, field) => {
    setEditingField((prev) =>
      prev.tokenId === tokenId && prev.field === field
        ? { tokenId: null, field: null }
        : { tokenId, field }
    );
  };

  const renderEditableField = (value, record, field,redirectedPoolId) => {
    const isEditing = editingField.tokenId === record.token_id && editingField.field === field;
    return (
      <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
        {isEditing ? (
          <Input
            defaultValue={value ?? 0}
            onBlur={async (e) => {
              const tokenId = record.token_id;
              const inputValue = parseFloat(e.target.value);
              handleInputChange(inputValue, tokenId, field, record);
            

              if (field === 'final_settlement_price' || field === 'broker_percentage') {
                const payload = {
                  token_id: tokenId,
                  pool_id: redirectedPoolId ? redirectedPoolId : "",
                  final_price: field === 'final_settlement_price' ? inputValue : FinalSPMap?.[tokenId] ?? 0,
                  broker_percentage: field === 'broker_percentage' ? inputValue : brokerageMap?.[tokenId] ?? 0,
                };
            
                console.log("Payload to update:", payload);
                await dispatch(UpdateFinalPrice([payload]));
              }
            
              toggleEdit(tokenId, field);
            }}
            
            autoFocus
          />
        ) : (
          <>
            <span>{value ?? 0}</span>
            <EditOutlined
              style={{ cursor: "pointer", fontSize: 14 }}
              onClick={() => toggleEdit(record.token_id, field)}
            />
          </>
        )}
      </div>
    );
  };

  const columns = [
    {
      title: "",
      dataIndex: "drag",
      key: "drag",
      width: 40,
      align: "center",
      onCell: (record) => {
        console.log("redirectedPoolData",redirectedPoolData)
        const isRedirected = redirectedPoolData?.some(item => item.token_id == record.token_id);
        console.log("redirectedPoolData",isRedirected)

        return {
          style: {
            backgroundColor: isRedirected ? "yellow" : undefined,
          },
        };
      },
      render: (_,record) => {
        const isRedirected = redirectedPoolData?.some(item => item.token_id === record.token_id);
        return (<div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <img
              src={dragIcon}
              alt="Drag Icon"
              style={{ width: 16, cursor: "grab", opacity: 0.7 }}
              draggable={false}
            />
          </div>
        )
      },
    },
    {
      title: (
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          Vessel Name
        </div>
      ),
      dataIndex: "vessel_name",
      key: "vessel_name",
      align: "left", // keeps cell values left-aligned
      width: 150,
    },
    {
      title: (
        <div style={{ display:"flex",justifyContent:"center",alignItems:"center", width: "100%" }}>
          {/* <img src={cbIcon} alt="CB Icon" style={{ width: 16 }} /> */}
          CB
        </div>
      ),
      dataIndex: "cb_wants_to_sell",
      key: "cb_wants_to_sell",
      align: "center", // centers both header and cell content
      width: 170,
      render: (value) => {
        const formatted = (
          Math.floor(Math.abs(value) / 10 ** 6 * 1000000) / 1000000
        ).toFixed(6);
        return (
          <div
            className="cb"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // center horizontally
              gap: 4,
            }}
          >
            <span>{addThousandSeparator(formatted)}</span>
          </div>
        );
      },
    },    
    {
      title: (
        <span style={{ textAlign: "center" }}>
          Expected <br /> (€/MT CO<sub>2</sub>e)
        </span>
      ),
      key: "expected",
      align: "center",
      width: 130,
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>
          {addThousandSeparator(record.expected_price_lv)} - {addThousandSeparator(record.expected_price_uv)}
        </div>
      ),
    },
    ...(type === "surplus"
      ? [
          {
            title: (
              <div style={{ textAlign: "center", width: "100%" }}>
                Brokerage <br /> (%)
              </div>
            ),
            dataIndex: "broker_percentage",
            key: "broker_percentage",
            width: 100,
            align: "right",
            render: (value, record) => (
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                {renderEditableField(value, record, "broker_percentage", redirectedPoolId)}
              </div>
            ),
          },
        ]
      : [
          {
            title: (
              <div style={{ textAlign: "center", width: "100%" }}>
                Brokerage <br /> (%)
              </div>
            ),
            dataIndex: "broker_percentage",
            key: "broker_percentage",
            width: 100,
            align: "right",
            render: (value, record) => (
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                {renderEditableField(value, record, "broker_percentage", redirectedPoolId)}
              </div>
            ),
          },
          {
            title: (
              <div style={{ textAlign: "center", width: "100%" }}>
                Final SP
              </div>
            ),
            dataIndex: "final_settlement",
            key: "final_settlement_price",
            width: 120,
            align: "right",
            render: (value, record) => (
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                {renderEditableField(value, record, "final_settlement_price", redirectedPoolId)}
              </div>
            ),
          },
        ]),
  ];

  let filteredData = [];

  if (type === "surplus") {
    filteredData = data
      .filter((item) => item.cb_wants_to_sell >= 0)
      .sort((a, b) => a.vessel_name.localeCompare(b.vessel_name));
  } else if (type === "deficit") {
    filteredData = data
      .filter((item) => item.cb_wants_to_sell < 0)
      .sort((a, b) => a.vessel_name.localeCompare(b.vessel_name));
  }

  return filteredData.length > 0 ? (
    <Table
      columns={columns}
      dataSource={filteredData}
      rowKey="token_id"
      className="manual-common-table"
      pagination={false}
      components={{
        body: {
          row: (props) => <DraggableTableRow {...props} dropApplied={dropApplied} />,
          cell: (props) => (
            <td {...props} style={{ padding: '8px 8px', ...props.style }}>
              {props.children}
            </td>
          ),
        },
      }}
      onRow={(record, index) => ({
        record,
        index,
        "data-row-key": record.token_id,
      })}
      scroll={{ y: scrollHeight }}
      bordered={true}
    />
  ) : (
    <Empty description="No vessels found for this category" />
  );
};

const DroppableContainer = ({
  allowedType,
  items,
  onDrop,
  dropApplied,
  handleRemove,
  isInitiatePoolClicked,
  poolStatus,
  setIsPoolDetailsModalOpen,
  shouldDisableButton,
  UpdatePoolDisableButton,
  handleReset,
  initiatedpoolingloading,
  updatepoolingloading,
  handleInitiatePool,
  handleDistribution,
  greenContainer,
  redContainer,
  isRedirectedFromPoolingHistory,
  setupdatePoolClicked,
  updatePoolClicked,
}) => {
  const [, drop] = useDrop(() => ({
    accept: allowedType,
    drop: (item) => {onDrop(item)},
  }));


  const totalCb = items.reduce((acc, item) => acc + item.cb_wants_to_sell / 10 ** 6, 0).toString().trim();
  const totalSurplusCb = greenContainer.reduce((acc, item) => acc + item.cb_wants_to_sell / 10 ** 6, 0).toString().trim();
  const totalDeficitCb = redContainer.reduce((acc, item) => acc + item.cb_wants_to_sell / 10 ** 6, 0).toString().trim();
  const isEmpty = items.length === 0;

  return (
    <div className="summary-section" ref={drop}>
      <div className="compliance-summary">
        <div className="pool-compliance-header-container">
          <h3 className="pool-compliance-header">Pool Compliance Balance</h3>
          {isInitiatePoolClicked || updatePoolClicked ? 
                <Button
                  className={`pool-result-details pooling-reset-btn ${!shouldDisableButton || !UpdatePoolDisableButton ? "active" : ""}`}
                  type="primary"
                  disabled={shouldDisableButton || UpdatePoolDisableButton}
                  onClick={handleReset}
                >
                  {initiatedpoolingloading || updatepoolingloading ? (
                    <VerticalBarLoader />
                  ) : (
                    [<img src={resetloadingIcon} />, " RESET"]
                  )}
                </Button> 
                : isRedirectedFromPoolingHistory ?
                <Button
                  className={`initiate-btn ${!UpdatePoolDisableButton ? "active" : "disable-btn"}`}
                  type="primary"
                  disabled={UpdatePoolDisableButton}
                  onClick={handleDistribution}
                >
                  {updatepoolingloading ? (
                    <VerticalBarLoader rotate={90} />
                  ) : (
                    [
                    // <img src={rocketIcon} />
                      <></>
                      , " UPDATE POOL"]
                  )}
                </Button>
                :
                <Button
                  className={`initiate-btn ${!shouldDisableButton ? "active" : "disable-btn"}`}
                  type="primary"
                  disabled={shouldDisableButton}
                  onClick={handleDistribution}
                >
                  {initiatedpoolingloading ? (
                    <VerticalBarLoader rotate={90} />
                  ) : (
                    [
                    // <img src={rocketIcon} />
                    <></>
                      , " INITIATE POOL"]
                  )}
                </Button>
              }
        </div>
        <div className="summary-cards">
          {items.map((item, index, array) => {
            const isSmallCard = array.length > 6;
            const isGreen = item.cb_wants_to_sell >= 0;

            return (
              <React.Fragment key={item.token_id}>
                {index > 0 && item.cb_wants_to_sell >= 0 ? (
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "20px",
                      margin: "0 10px",
                      color: "#678DFF"
                    }}
                  >
                    +
                  </span>
                ) : item.cb_wants_to_sell < 0 ? (
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "20px",
                      margin: "0 11px",
                      color: "#FF6347"
                    }}
                  >
                    -
                  </span>
                ) : null}

                <div
                  className={`summary-card ${isSmallCard ? "small" : ""} ${
                    isGreen ? "summary-card-green" : "summary-card-red"
                  }`}
                >
                  <div className="summary-card-header">
                    <span className="summary-card-label">{item.vessel_name} <Button
                      className="remove-btn"
                      disabled={dropApplied}
                      onClick={() =>
                        handleRemove(item.token_id, isGreen ? "green" : "red")
                      }
                    >
                      <img src={closeIcon} alt="close" />
                    </Button></span>
                    <div className={isGreen ? "cb-green" : "cb-red"}>
                      {addThousandSeparator(
                        (
                          Math.floor(
                            Math.abs(item.cb_wants_to_sell) / 10 ** 6 * 1000000
                          ) / 1000000
                        ).toFixed(6)
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>

      <div className={`pool-results ${isInitiatePoolClicked ? poolStatus ? "green" : "red" : ""}`}>


        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", gap: 5 }}>
          {/* Row 1: Two boxes */}
          {/* <div style={{ display: "flex", gap: 5 }}> */}
            <div
              style={{
                display:"flex",
                width:"100%",
                height: "100%",
                flexDirection: "column",
                alignItems:"flex-start",
                backgroundColor: "rgba(12, 200, 118, 0.08)",
                border: "1px solid rgba(42, 69, 57, 0.08)",
                color: "#0CC876",
                padding: "5px",
                borderRadius: "8px",
                fontWeight: "500",
                gap:"0.8vh",
                boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.08)",
              }}
            >
              <span style={{
                fontWeight: "500",
                fontSize: "16px",
              }}>Total Surplus</span>
            <span className="pool-result-total-cb" style={{fontSize:"16px"}}><img src={cbGreenIcon} width={20} height={20} alt="cb-icon" />{(Math.floor(totalSurplusCb * 1000000) / 1000000).toFixed(6)}</span>
            </div>
            <div
              style={{
                display:"flex",
                width:"100%",
                height: "100%",
                flexDirection: "column",
                alignItems:"flex-start",
                backgroundColor: "rgba(251, 47, 47, 0.08)",
                border:'1px solid rgba(72, 27, 27, 0.08)',
                color: "#FB2F2F",
                padding: "5px",
                borderRadius: "8px",
                fontWeight: "500",
                gap:"0.8vh",
                boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.08)",
              }}
            >
              <span style={{
                fontWeight: "500",
                fontSize: "16px",
              }}>Total Deficit</span>
            <span className="pool-result-total-cb" style={{fontSize:"16px"}}><img src={cbRedIcon} width={20} height={20} alt="cb-icon" />{Math.abs(Math.floor(totalDeficitCb * 1000000) / 1000000).toFixed(6)}</span>
            </div>
          {/* </div> */}

          <div
            style={{
              display:"flex",
              width:"100%",
              height:"100%",
              flexDirection: "column",
              alignItems:"flex-start",
              justifyContent:"flex-start",
              backgroundColor: totalCb < 0 ? "rgba(251, 47, 47, 0.08)" : "rgba(12, 200, 118, 0.08)", 
              border: totalCb < 0 ? "1px solid rgba(72, 27, 27, 0.08)" : "1px solid rgba(42, 69, 57, 0.08)",
              color: totalCb < 0 ? "#FB2F2F" : '#0CC876',
              padding: "5px",
              borderRadius: "8px",
              fontWeight: "500",
              gap:"0.8vh",
              boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.08)",
            }}
          >
            <span style={{
                fontWeight: "500",
                fontSize: "16px",
              }}>Total CB</span>
            <span className="pool-result-total-cb" style={{fontSize:"16px"}}><img src={totalCb < 0 ? cbRedIcon : cbGreenIcon} width={20} height={20} alt="cb-icon" />{(Math.floor(totalCb * 1000000) / 1000000).toFixed(6)}</span>
          </div>
        </div>


        
        {/* {isInitiatePoolClicked ? (
          <>
            <div className="pool-result-details">
              <label className="pool-result-total-header" style={{ color: "white" }}>
                Total CB
              </label>
              <p className="pool-result-total-cb">
                <img src={cbWhiteIcon} alt="cb-icon" />
                {totalCb > 0 ? "+" : ""}{" "}
                {addThousandSeparator(
                  (Math.floor(totalCb * 1000000) / 1000000).toFixed(6)
                )}
              </p>
            </div>

            <Button
              className={`pooling-view-details ${poolStatus ? "green" : "red"}`}
              onClick={() => {
                setIsPoolDetailsModalOpen(true);
              }}
            >
              <img src={poolStatus ? greenEyeIcon : redEyeIcon} alt="view" />
              View Details
            </Button>
          </>
        ) : (
          <div className="pool-result-details">
            <label className="pool-result-total-header" style={{ color: "white" }}>
              Total CB
            </label>
            <p className="pool-result-total-cb">
              <img src={cbWhiteIcon} alt="cb-icon" />
              {totalCb > 0 ? "+" : ""}{" "}
              {addThousandSeparator(
                (Math.floor(totalCb * 1000000) / 1000000).toFixed(6)
              )}
            </p>
          </div>
        )} */}

        {/* {!isInitiatePoolClicked && (
          <span className="text-pool-result">Initiate Pool to View Results</span>
        )} */}
      </div>
    </div>
  );
};




export default Pooling;
